﻿/* eslint-disable-next-line */
import getTransitionDuration from 'get-transition-duration';
export class LeadManagement {
  /**
   * Controller for LeadManagement view
   * @param {HTMLElement} element LeadManagement
   */
  constructor(element) {
    // Name, reference
    element.LeadManagement = this;

    this._refs = {
      form: element.querySelector('.lead-management__filters'),
      filters: Array.from(element.querySelectorAll('.lead-management__filters select')),
      items: Array.from(element.querySelectorAll('.datatable__item')),
      error: element.querySelector('.alert-info'),
    };

    this.dictionary = JSON.parse(element.dataset.dictionary);

    // Bindings
    this._dispatchEvents();

    if (this._refs.filters) {
      this._refs.filters.forEach((x) =>
        x.addEventListener('change', this._onFilterItemChange.bind(this)),
      );
    }

    document.addEventListener('datatable.paginate', () => {
      this._refs.items.forEach((item) => {
        item.classList.remove('is-active');
        this._resetQuestionaire(item);
      });
    });
  }

  /**
   * onFilterItemChange
   * Handler for filter leads
   * @param {Event} e - Event interface
   */
  _onFilterItemChange() {
    this._refs.form.submit();
  }

  /**
   * dispatchEvents
   * Event dispacther based on available actions in a item
   */
  _dispatchEvents() {
    this._refs.items.forEach((item) => {
      // Toggling of content
      const oToggl = item.querySelector('.lead-management__item-toggl'),
        oDecline = item.querySelector('.lead-management__item-decline'),
        oAccept = item.querySelector('.lead-management__item-accept'),
        oComplete = item.querySelector('.lead-management__item-complete');

      if (oToggl != null) {
        oToggl.addEventListener('click', this._onItemToggl.bind(this, item));
      }

      // Toggl alert for declining
      if (oDecline != null) {
        oDecline.addEventListener('click', this._onItemMessageToggl.bind(this, item));
      }

      // Accept a lead
      if (oAccept != null) {
        oAccept.addEventListener('click', this._onItemAccept.bind(this, item));
      }

      // Complete a lead by starting event flow
      if (oComplete != null) {
        oComplete.addEventListener('click', this._onItemComplete.bind(this, item));
      }
    });
  }

  /**
   * onItemToggl
   * Event for toggling lead content
   * @param {HTMLElement} item - current item
   * @param {Event} e - event interface
   */
  _onItemToggl(item, e) {
    e.preventDefault();
    this._togglContent(item);
  }

  /**
   * Toggl
   * Toggle content for a lead
   * @param {HTMLElement} - Current lead item
   */
  _togglContent(item) {
    if (item.classList.contains('is-active')) {
      item.classList.remove('is-active');
      this._resetQuestionaire(item);
    } else {
      item.classList.add('is-active');
    }
  }

  /**
   * _onItemMessageToggl
   * Toggle an overlay for an item to show an message and two triggers
   * @param {HTMLElement} item - current item
   * @param {Event} e - event interface
   */
  _onItemMessageToggl(item, e) {
    e.preventDefault();

    const oContent = item.querySelector('.lead-management__item-message');
    if (oContent === null) {
      return false;
    }

    const oConfirm = oContent.querySelector('.lead-management__item-message__confirm'),
      oCancel = oContent.querySelector('.lead-management__item-message__cancel');

    oContent.classList.add('is-active');

    // Bind events
    if (oCancel != null) {
      const handler = (e) => {
        e.preventDefault();
        oContent.classList.remove('is-active');
        oCancel.removeEventListener('click', handler);
        oConfirm.removeEventListener('click', this._onItemDecline);
      };

      oCancel.addEventListener('click', handler);
    }

    if (oConfirm != null) {
      oConfirm.addEventListener('click', this._onItemDecline.bind(this, item));
    }
  }

  /**
   * _onItemDecline
   * When a user declines a lead
   * @param {HTMLElement} item - current item
   * @param {Event} e - Event interface
   */
  _onItemDecline(item, e) {
    e.preventDefault();
    const oButton = e.target,
      oContent = item.querySelector('.lead-management__item-message'),
      args = {
        id: item.dataset.id,
        action: 'Declined',
      },
      resolve = () => {
        const oTime = item.children[0].children[4],
          oState = item.children[0].children[5],
          oControlPending = item.querySelector('.lead-management__controls--pending');
        // Remove time left
        if (oTime != null) {
          oTime.innerHTML = '';
        }
        if (oState != null) {
          oState.classList.remove('is-pending');
          oState.classList.add('is-declined');
          oState.setAttribute('data-sort', '3');
          oState.innerHTML = this.dictionary.declined;
        }
        oControlPending.classList.add('is-hidden');
        oContent.classList.remove('is-active');
      },
      reject = () => {
        oButton.classList.remove('is-disabled');
        oContent.classList.remove('is-active');
      };
    if (!oButton.classList.contains('is-disabled')) {
      oButton.classList.add('is-disabled');
      this._updateItem(args, resolve, reject);
    }
  }

  /**
   * onItemAccept
   * User acccepts a lead
   * @param {HTMLElement} - current item
   * @param {Event} - Event interface
   **/
  _onItemAccept(item, e) {
    e.preventDefault();

    const oButton = e.target,
      args = {
        id: item.dataset.id,
      },
      resolve = () => {
        const oTime = item.children[0].children[4],
          oState = item.children[0].children[5],
          oControlPending = item.querySelector('.lead-management__controls--pending'),
          oControlInProgress = item.querySelector('.lead-management__controls--inprogress'),
          oToggl = item.querySelector('.lead-management__item-toggl');

        if (oTime != null) {
          oTime.innerHTML = '';
        }
        if (oState != null) {
          oState.classList.remove('is-pending');
          oState.classList.add('is-inprogress');
          oState.setAttribute('data-sort', '1');
          oState.innerHTML = this.dictionary.inprogress;
        }
        // Switch controls
        oControlPending.classList.add('is-hidden');
        oControlInProgress.classList.remove('is-hidden');
        oToggl.classList.remove('is-hidden');

        // Toggl content
        this._togglContent(item);
      },
      reject = () => {
        // Release
        e.target.classList.remove('is-disabled');
      };

    // State
    if (!oButton.classList.contains('is-disabled')) {
      e.target.classList.add('is-disabled');
      this._updateItem(args, resolve, reject);
    }
  }

  /**
   * onSubmitStatus
   * When a user changes a state for an lead item
   * @param {Object} args - arguments for creating correct api call
   * @param {Function} resolve - Callback to execute once a request has been completed without errors
   * @param {Function} reject - Callback to execute once a request has failed eg.
   * args.data ||
   */
  _updateItem(args, resolve, reject) {
    const options = {
        id: args.id || '00000000000000000',
        action: args.action || 'In Progress',
        data: args.data || '',
      },
      getEndpoint = (options) => {
        const base = ['/api/lead-management'];
        if (Object.keys(options.data).length) {
          base.push('complete');
        } else {
          base.push('status');
        }
        base.push(options.id);
        if (!Object.keys(options.data).length) {
          base.push(options.action);
        } else {
          base.push(options.data);
        }
        return base.join('/');
      },
      HTTP = new XMLHttpRequest();

    HTTP.open('PUT', getEndpoint(options));

    // Payload?
    if (options.data) {
      HTTP.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    }

    HTTP.onreadystatechange = () => {
      switch (HTTP.readyState) {
        case 4:
          // Reponsetype
          if (HTTP.status === 200) {
            if (typeof resolve === 'undefined' || typeof resolve !== 'function') {
              location.reload();
            }
            resolve();
          } else {
            if (typeof reject !== 'undefined' || typeof reject !== 'function') {
              reject();
            }
            // Error handling
            this._onError();
          }
          break;
      }
    };

    HTTP.send(JSON.stringify(options.data));
  }

  /**
   * onError
   * If a error happens once communicating with the server, we show a generic error message
   */
  _onError() {
    this._refs.error.classList.remove('is-hidden');
    setTimeout(() => {
      this._refs.error.classList.add('is-hidden');
    }, 5000);
  }

  /**
   * onItemComplete
   * When user completes a lead and starts a feedback session
   * @param {HTMLElement} item - Current Item
   * @param {Event} e - Event interface
   */
  _onItemComplete(item, e) {
    e.preventDefault();

    const oQuestionaire = item.querySelector('.lead-management__questionaire');
    if (oQuestionaire == null) {
      return false;
    }

    if (!oQuestionaire.classList.contains('is-active')) {
      const intCurrentStep = parseInt(item.getAttribute('data-complete-step'));
      if (intCurrentStep == -1) {
        item.setAttribute('data-complete-step', '0');

        this._showStep(item);

        const arrButtons = Array.from(
            oQuestionaire.querySelectorAll('.lead-management__item-question-next'),
          ),
          oButtonPrevius = oQuestionaire.querySelector('.lead-management__questionaire-link');

        arrButtons.forEach((x) =>
          x.addEventListener('click', (e) => {
            this._nextPrev(1, item, e.currentTarget);
          }),
        );

        if (oButtonPrevius) {
          oButtonPrevius.addEventListener('click', (e) => {
            e.preventDefault();
            this._nextPrev(-1, item, e.currentTarget);
          });
        }

        const oCompleteSelect = oQuestionaire.querySelector(
            '.lead-management__item-question-select',
          ),
          oSubmitButton = item.querySelector('.lead-management__item-complete-submit');

        if (oCompleteSelect != null) {
          /* eslint-disable-next-line */
          oCompleteSelect.addEventListener('change', (event) => this._onSelectChange(item));

          const oRadios = Array.from(
            item.querySelectorAll('.lead-management__item-complete-radio'),
          );
          oRadios.forEach((x) =>
            x.addEventListener('click', (event) => {
              item.setAttribute('data-complete-q3-select', event.target.dataset.value);
              oSubmitButton.disabled = false;
            }),
          );
        }

        if (oSubmitButton != null) {
          oSubmitButton.addEventListener('click', (event) => this._onCompleteSubmit(item, event));
        }
      } else if (intCurrentStep == 0) {
        this._showStep(item);
      }

      oQuestionaire.classList.add('is-active');

      const oConfirm = item.querySelector('.lead-management__item-complete'),
        oCancel = item.querySelector('.lead-management__item-cancel');

      oConfirm.classList.add('is-hidden');
      oCancel.classList.remove('is-hidden');

      // Bind events
      if (oCancel != null) {
        const callback = (e) => {
          e.preventDefault();
          this._togglContent(item);

          oCancel.removeEventListener('click', callback);
        };
        oCancel.addEventListener('click', callback);
      }

      if (!item.classList.contains('is-active')) {
        this._togglContent(item);
      }
    } else {
      oQuestionaire.classList.remove('is-active');
      this._togglContent(item);
    }
  }

  /**
   * resetQuestionaire
   * Full reset of questionaire
   * @param {HTMLElement} item - current lead item
   */
  _resetQuestionaire(item) {
    const oConfirm = item.querySelector('.lead-management__item-complete'),
      oCancel = item.querySelector('.lead-management__item-cancel'),
      oQuestionaire = item.querySelector('.lead-management__questionaire'),
      arrSteps = Array.from(item.querySelectorAll('.lead-management__questionaire-step'));

    if (oQuestionaire != null) {
      // Reset
      arrSteps.forEach((step) => step.classList.remove('is-active'));
      oQuestionaire.classList.remove('is-active');
      oConfirm.classList.remove('is-hidden');
      oCancel.classList.add('is-hidden');

      // Step control
      item.setAttribute('data-complete-step', '-1');
    }
  }

  /**
   * showStep
   * When user starts a feedback session it shows question one by one
   * @param {HTMLElement} item - Current Item
   */
  _showStep(item) {
    const oCurrentStep = parseInt(item.getAttribute('data-complete-step'));
    const x = item.querySelectorAll('.lead-management__questionaire-step');
    x[oCurrentStep].classList.add('is-active');

    if (oCurrentStep == 0) {
      item.querySelector('.lead-management__questionaire-link').classList.add('is-hidden');
    } else {
      item.querySelector('.lead-management__questionaire-link').classList.remove('is-hidden');
    }
  }

  /**
   * nextPrev
   * When user starts a feedback session and answer/back it shows question next/prev question and sets the data-step-value in item tag
   * @param {int} n - depends on step forward(1) or backword(-1)
   * @param {HTMLElement} item - Current Item
   */
  _nextPrev(n, item, targetElement) {
    // This function will figure out which step to display
    const x = item.querySelectorAll('.lead-management__questionaire-step');
    // Hide the current step:
    let oCurrentStep = parseInt(item.getAttribute('data-complete-step'));
    x[oCurrentStep].classList.remove('is-active');
    // Increase or decrease the current step by 1:
    oCurrentStep = oCurrentStep + n;
    item.setAttribute('data-complete-step', oCurrentStep.toString());
    if (event.target.classList.contains('yes')) {
      item.setAttribute('data-complete-q' + oCurrentStep.toString(), 'yes');
    } else if (event.target.classList.contains('no')) {
      item.setAttribute('data-complete-q' + oCurrentStep.toString(), 'no');
    }
    // Check if target element triggers completion of feedback flow
    if (targetElement.getAttribute('data-action-complete')) {
      this._onCompleteSubmit(item);
      return true;
    }
    // if you have reached the end of the form...
    if (oCurrentStep >= x.length) {
      return false;
    }
    // Otherwise, display the correct step:
    this._showStep(item);
  }

  /**
   * Selection of answers at question 3
   * @param {HTMLElement} item - current item
   */
  _onSelectChange(item) {
    const oSelect = item.querySelector('.lead-management__item-question-select'),
      oSubmitButton = item.querySelector('.lead-management__item-complete-submit'),
      oRadios = item.querySelectorAll('.lead-management__item-complete-radio');

    item.setAttribute('data-complete-q3', oSelect.options[oSelect.selectedIndex].value);

    oSubmitButton.disabled = true;

    if (oSelect.selectedIndex > 1) {
      oSubmitButton.disabled = false;
    }

    let oCurrentProduct = item.querySelector('.lead-management__questionaire-control--list');
    if (oCurrentProduct == null) {
      return false;
    }

    if (oSelect.selectedIndex == '1') {
      oCurrentProduct.classList.remove('is-hidden');
      for (let i = 0; i < oRadios.length; i++) {
        if (oRadios[i].checked) {
          oSubmitButton.disabled = false;
        }
      }
    } else {
      oCurrentProduct.classList.add('is-hidden');
      item.removeAttribute('data-complete-q3-select');
    }
  }

  /**
   * On submit of the feedback flow
   * @param {HTMLElement} item - Current item
   * @param {Event} e - Event interface
   */
  _onCompleteSubmit(item, e) {
    if (e) {
      e.preventDefault();
    }
    const args = {
        id: item.dataset.id,
        data: this._getQuestions(item),
      },
      resolve = () => {
        const oState = item.children[0].children[5],
          oControlInProgress = item.querySelector('.lead-management__controls--inprogress'),
          oQuestionsData = item.querySelector('.lead-management__questionaire'),
          oCompletedData = item.querySelector('.lead-management__questionaire-result'),
          oToggl = item.querySelector('.lead-management__item-toggl');

        if (oState != null) {
          oState.classList.remove('is-inprogress');
          oState.classList.add('is-completed');
          oState.innerHTML = this.dictionary.completed;
          oState.setAttribute('data-sort', '4');
        }

        // Switch controls
        oControlInProgress.classList.add('is-hidden');
        oQuestionsData.classList.remove('is-active');
        oCompletedData.classList.remove('is-hidden');
        oToggl.classList.remove('is-hidden');
        //filling data with questions answers

        const oCompletedQ1 = item.querySelector('.lead-management__item-complete-data-q1'),
          oCompletedQ2 = item.querySelector('.lead-management__item-complete-data-q2'),
          oCompletedQ3 = item.querySelector('.lead-management__item-complete-data-q3');

        oCompletedQ1.innerHTML = item.dataset.completeQ1 || '-';
        oCompletedQ2.innerHTML = item.dataset.completeQ2 || '-';
        oCompletedQ3.innerHTML =
          item.dataset.completeQ3 +
            (typeof item.dataset.completeQ3Select != 'undefined'
              ? ': ' + item.dataset.completeQ3Select
              : '') || '-';
      },
      reject = () => {
        // Release
        e.target.classList.remove('is-disabled');
      };
    // State
    if (e && !e.target.disabled) {
      e.target.disabled = true;
      this._updateItem(args, resolve, reject);
    } else {
      this._updateItem(args, resolve, reject);
    }
  }

  /**
   * getModel
   * Return an object containg questionaire model
   * @param {any} item - current item
   */
  _getQuestions(item) {
    return {
      Question1: item.dataset.completeQ1 || '-',
      Question2: item.dataset.completeQ2 || '-',
      Question3:
        item.dataset.completeQ3 +
          (typeof item.dataset.completeQ3Select != 'undefined'
            ? ': ' + item.dataset.completeQ3Select
            : '') || '-',
      Question4: '',
    };
  }
}
